import { useQuery } from '@tanstack/react-query';
import {
  getOrganisationUsers,
  searchUsers,
  UserSummaryDto,
  SearchUsersResponse,
} from '../api/userManagementApi';
import { useAuthStore } from '../../auth/stores/authStore';
import { userKeys } from './userKeys';

export function useUsers() {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);

  return useQuery<UserSummaryDto[], Error>({
    queryKey: userKeys.lists(),
    queryFn: async () => {
      const result = await getOrganisationUsers();
      return result.users;
    },
    placeholderData: previousData => previousData,
    enabled: isAuthenticated,
  });
}

export function useUserSearch(
  query: string,
  limit?: number,
  continuationToken?: string
) {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);

  return useQuery<SearchUsersResponse, Error>({
    queryKey: userKeys.search(query, limit, continuationToken),
    queryFn: () => searchUsers(query, limit, continuationToken),
    placeholderData: previousData => previousData,
    enabled: isAuthenticated && query.length >= 3,
  });
}
